import { RefObject, useEffect } from 'react';
import { useYmaps } from './useYmaps';
import { TPanorama } from '../types';

interface IUsePanoramaPlayerParams {
  panorama: TPanorama;
  panoramaContainerRef: RefObject<HTMLDivElement | null>;

  onClose: VoidFunction;
}

export const usePanoramaPlayer = ({ panorama, panoramaContainerRef, onClose }: IUsePanoramaPlayerParams) => {
  const ymaps = useYmaps();

  useEffect(() => {
    if (!panoramaContainerRef.current || !ymaps) {
      return;
    }

    const player = new ymaps.panorama.Player(panoramaContainerRef.current, panorama, {
      controls: ['zoomControl', 'closeControl'],
      suppressMapOpenBlock: true,
    });

    player.events.add('destroy', () => {
      /**
       * На мобвебе есть проблема сквозного прокликивания:
       *
       * После клика на крестик в модалке панорамы событие destroy не перехватывает этот клик, а просто выполняет onClose.
       * Тем самым само событие клика срабатывает на элементе прямо под крестиком.
       * Если открыть панораму в самом верху страницы, то этим элементом будет кнопка на шапке.
       * Поэтому добавляем небольшой таймаут, чтобы клик не сработал
       *
       */
      setTimeout(onClose, 10);
    });
  }, [onClose, panorama, panoramaContainerRef, ymaps]);
};
